export enum RecaptchaV2ResetRequiredMode {
    ApiOnly,
    FormAndApi
}
